const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("../../office/modals/OfficeModal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const EstimateShipping = require("../../office/checkout/EstimateShipping");
const CopyTable = require("../../office/data/CopyTable");
const UnderlineView = require("../../office/UnderlineView");
const Link = require("../../core/view/Link");
const LoadingCircle = require("../../core/view/LoadingCircle");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const URLMake = require("../../../shared/URLMake");
const AT = require("../../core/vault/ActionTypes");
const ItemSummary = require("../../office/ItemSummary");
const CouponInput = require("../../office/checkout/CouponInput");

const styles = require("./styles/SubscriptionSummary.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "SubscriptionSummary",

		propTypes: {
			// Data computed from account. Use SubscriptionSummaryAccount.jsx if you
			// want these computations done for you.
			priceInfo: PT.object,
			priceLoadStatus: PT.string.isRequired,
			needsShipping: PT.bool.isRequired,
			changeWarningInfo: PT.object,
			blockingMessage: PT.string,
			couponInfo: PT.object,
			couponExtraInfo: PT.object,

			showItemize: PT.bool,
			hideSubNames: PT.bool,
			onContinue: PT.func,
			showError: PT.bool,
			buttonText: PT.string,
			extraInfo: PT.node,
			hideFinalButtons: PT.bool,
			hideLink: PT.bool,
			tabIndex: PT.number,
			className: PT.string,
			prorateInfo: PT.object,
			upgradeInfo: PT.object,

			needsPlanType: PT.bool,
			needsBundleGrades: PT.bool,
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
			};
		},

		onRetryPrices: function() {
			this.props.dispatch({type: AT.SUBSCRIPTION_CHANGE_GET_PRICES_RETRY});
		},

		onContinue: function(evt) {
			this.props.onContinue && this.props.onContinue();
		},

		onKeyPress: function(evt) {
			if (evt.which === 13) {
				this.onContinue();
			}
		},

		openModal: function() {
			this.setState({isModalOpen: true});
		},

		closeModal: function() {
			this.setState({isModalOpen: false});
		},

		blurContinueButton: function() {
			this.continueButton.blur();
		},

		renderExpires: function() {
			const {changeWarningInfo} = this.props;
			if (!changeWarningInfo) return null;
			return (
				<div className={styles.expiresAt}>
					{CopyTable.getSubscriptionChangeWarning(changeWarningInfo)}
				</div>
			);
		},

		renderButton: function(errors, isDisabled = false) {
			const buttonText = this.props.buttonText || "continue";

			if (isDisabled) {
				return (
					<div className={styles.buttonContainer}>
						{errors}
						<div className={styles.continueDisabled}>{buttonText}</div>
					</div>
				);
			}
			return (
				<div className={styles.buttonContainer}>
					{errors}
					<div
						className={styles.continue}
						ref={b => (this.continueButton = b)}
						onContextMenu={this.blurContinueButton}
						onClick={this.onContinue}
						tabIndex={this.props.tabIndex}
						onKeyPress={this.onKeyPress}
					>
						{buttonText}
					</div>
				</div>
			);
		},

		renderItemSummary: function(
			priceInfo,
			couponInfo,
			couponExtraInfo,
			asteriskTotal
		) {
			if (!priceInfo) {
				return (
					<div className={styles.content}>
						<div className={styles.loadingContainer}>
							<div className={styles.loading}>
								<LoadingCircle colorType="transparentGray" />
							</div>
						</div>
					</div>
				);
			}

			// don't show items if bundle grade is not yet chosen
			const items = this.props.needsBundleGrades ? [] : priceInfo.items;
			return (
				<ItemSummary
					items={items}
					couponCode={couponInfo.code}
					itemsPrebundled={true}
					upgradeInfo={this.props.upgradeInfo}
					{...priceInfo.totals}
					showItemize={this.props.showItemize}
					showShippingIfAvailable={true}
					hideSubNames={this.props.hideSubNames}
					asteriskTotal={asteriskTotal}
					couponExtraInfo={couponExtraInfo}
					prorateInfo={this.props.prorateInfo}
				/>
			);
		},

		render: function() {
			const {
				priceInfo,
				couponInfo,
				priceLoadStatus,
				needsShipping,
				blockingMessage,
				dispatch,
				className,
				showItemize,
				showError,
				hideFinalButtons,
				extraInfo,
				couponExtraInfo,
			} = this.props;

			const title = (
				<div className={styles.title}>
					Subscription
					<br />
					<UnderlineView text="Order Summary" />
				</div>
			);

			let myAccount = null;
			if (!this.props.hideLink) {
				myAccount = (
					<Link className={styles.myAccount} to={URLMake.forAccount()}>
						Back to Account
					</Link>
				);
			}

			const mainClass = styles.main + " " + (className || styles.mainDefault);

			if (blockingMessage) {
				const messageEl = (
					<div className={styles.blocking}>{blockingMessage}</div>
				);
				return (
					<div className={mainClass}>
						{title}
						<div className={styles.content}>
							{this.props.needsPlanType
								? null
								: this.renderItemSummary(
										priceInfo,
										couponInfo,
										couponExtraInfo,
										asteriskTotal
								  )}
							{!this.props.needsPlanType ? null : (
								<div className={styles.spacer} />
							)}
							{this.renderButton(messageEl, true)}
							{myAccount}
						</div>
					</div>
				);
			} else if (priceLoadStatus === "error") {
				return (
					<div className={mainClass}>
						{title}
						<div className={styles.content}>
							<div className={styles.retryErrorContainer}>
								<div className={styles.retryError}>
									There was an issue loading the pricing information for your
									order.
								</div>
								<div className={styles.retry} onClick={this.onRetryPrices}>
									Click here to retry.
								</div>
							</div>
							{this.renderButton(null, true)}
							{myAccount}
						</div>
					</div>
				);
			} else if (!priceInfo) {
				return (
					<div className={mainClass}>
						{title}
						<div className={styles.content}>
							<div className={styles.loadingContainer}>
								<div className={styles.loading}>
									<LoadingCircle colorType="transparentGray" />
								</div>
							</div>
							{this.renderButton(null, true)}
							{myAccount}
						</div>
					</div>
				);
			}

			let calculate = null;
			if (needsShipping && priceInfo.totals.shipping === null) {
				calculate = (
					<div className={styles.calcOuter}>
						<div className={styles.calculate} onClick={this.openModal}>
							Estimate Shipping
						</div>
					</div>
				);
			}
			let errors = null;

			if (showItemize && showError) {
				errors = (
					<div className={styles.errors}>
						{CopyTable.getFormErrorCopy().general}
					</div>
				);
			}

			let modal = null;
			const fakeCart = {
				items: priceInfo.items,
				prices: priceInfo.totals,
			};
			if (this.state.isModalOpen) {
				modal = (
					<OfficeModal
						portalContainer={PORTAL_CONTAINERS.CHECKOUT}
						onClose={this.closeModal}
						modalClass={styles.modal}
						level="overBar"
					>
						<EstimateShipping cart={fakeCart} />
					</OfficeModal>
				);
			}

			let button = null;
			let couponInput = null;
			if (!hideFinalButtons) {
				button = this.renderButton(errors, !!this.props.needsPlanType);
				couponInput = (
					<CouponInput
						couponInfo={couponInfo}
						dispatch={dispatch}
						forSubscriptionFlow={true}
					/>
				);
			}

			let asteriskTotal = false;
			if (_.get(this.props, "changeWarningInfo.delayedChange", false)) {
				asteriskTotal = true;
			}

			let couponCopy;
			const {remainingBalance} = couponExtraInfo || {};
			if (couponInfo.code && remainingBalance.gt(0)) {
				couponCopy = (
					<div className={styles.expiresAt}>
						{CopyTable.getCouponExtraCopy(
							priceInfo.totals.couponApplied,
							remainingBalance.toFixed(2)
						)}
					</div>
				);
			}

			return (
				<div className={mainClass}>
					{title}
					{extraInfo}
					<div className={styles.content}>
						{this.renderItemSummary(
							priceInfo,
							couponInfo,
							couponExtraInfo,
							asteriskTotal,
							mainClass,
							title,
							myAccount
						)}
						{couponInput}
						{calculate}
						{this.renderExpires()}
						{couponCopy}
						{button}
						{myAccount}
					</div>
					{modal}
				</div>
			);
		},
	})
);
